import { PlanningNoteAnalysisResponse, SurgeryMetadataSuggestion } from '~/clients/derived-api-types'

type SuggestionsLike = Partial<PlanningNoteAnalysisResponse> | SurgeryMetadataSuggestion | null | undefined

type NonWaitingAvailabilityPeriod = Exclude<NonNullable<PlanningNoteAnalysisResponse['availability_periods']>[number], { type: 'waiting' }>

export function normalizePlanningNoteAnalysisSuggestions(suggestions: SuggestionsLike): Partial<PlanningNoteAnalysisResponse> | null {
    if (!suggestions) return null

    const periods = suggestions.availability_periods ?? null
    const filteredPeriods = periods?.filter((period): period is NonWaitingAvailabilityPeriod => period.type !== 'waiting') ?? null

    const hasLegacyWaitingPeriod = periods?.some(period => period.type === 'waiting') ?? false
    if (!hasLegacyWaitingPeriod) {
        return suggestions as Partial<PlanningNoteAnalysisResponse>
    }

    return {
        ...suggestions,
        availability_periods: filteredPeriods,
        is_waiting: suggestions.is_waiting ?? true,
    }
}
